// fonts
const FONT_FAMILY = 'DM Sans, sans-serif'
export {
  FONT_FAMILY as default
}